export default __webpack_public_path__ + "static/media/warp_knitted.8e672057.png";